import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class MetadataModalBooleanStoreService {
  private booleanSubject = new BehaviorSubject<boolean>(false);

  setBooleanValue(value: boolean): void {
    this.booleanSubject.next(value);
  }

  getBooleanValue(): BehaviorSubject<boolean> {
    return this.booleanSubject;
  }
}